import { ItemResponseNotificationSettingBeanObject, ListResponseNotificationSettingBean, NotificationSettingBean, NotificationSettingControllerApi } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class NotificationSettingApi extends BaseApi {
    api: NotificationSettingControllerApi

    constructor() {
        super()
        this.api = new NotificationSettingControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(): Promise<ListResponseNotificationSettingBean> {
        return this.call(() => this.api.notificationSettingList())
    }

    async view(id: any): Promise<ItemResponseNotificationSettingBeanObject> {
        return this.call(() => this.api.notificationSetting(id))
    }

    async edit(id: any, setting: NotificationSettingBean): Promise<ItemResponseNotificationSettingBeanObject> {
        return this.call(() => this.api.editNotificationSetting(setting, id))
    }
}

const notificationSettingApi = new NotificationSettingApi()
export default notificationSettingApi



// WEBPACK FOOTER //
// ./src/component/app/notificationSetting/NotificationSettingApi.ts